/* Footer-animation JavaScript/jQuery */
jQuery(function( $ ) {

    sb_when( '#site-footer', function() {

        $( '#site-footer .social-media-links a' ).on( 'mouseenter', function() {
            $( this ).animateCss( 'swing' );
        });

        // Push footer to bottom on load of short pages
        // If using a fixed nav, comment out "- $( '.navbar' ).outerHeight()" below
        function pushFooterDown() {

            let minHeight =
                $( window ).height()
                - $( '.navbar' ).outerHeight()
                - $( '#page-header' ).outerHeight()
                - $( '#site-footer' ).outerHeight();

            $( '#content' ).css( 'min-height', minHeight + 'px' );
        }


        $( '#site-footer' ).show();

        $( window ).on( 'load resize',
            _.debounce( pushFooterDown, 150 )
        );

    });

    sb_when( '#affiliate-links-slider', function() {

        // Affiliate Links
        var affiliateLinksSlider = $( '#affiliate-links-slider' ),
            affiliateLinksSlides = affiliateLinksSlider.children( '.slide' ),
            affiliateLinksHandle = $( '#affiliate-links-handle' );

        affiliateLinksSlider.on( 'init', function( event, slick ){
            // load slick, but hide contents.
            if ( Cookies.get( 'affiliate-links-hidden' ) != undefined ) {
                setTimeout( function() {
                    $( '#affiliate-links' ).collapse();
                }, 300 );
            }
        });

        affiliateLinksHandle.on( 'click', function() {
            if ( $( '#affiliate-links' ).hasClass( 'show' ) ) {
                Cookies.set( 'affiliate-links-hidden', true );
            } else {
                Cookies.remove( 'affiliate-links-hidden' );
                $( window ).trigger( 'resize' );
            }
        });

        affiliateLinksSlider.slick({
            dots: false,
            infinite: true,
            speed: 500,
            fade: false,
            mobileFirst: true,
            arrows: false,
            autoplay: false,
            pauseOnHover: true,
            slidesToShow: 2,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        arrows: true,
                        prevArrow: '<div type="button" class="slick-prev text-primary"><i class="fas fa-chevron-circle-left"></i></div>',
                        nextArrow: '<div type="button" class="slick-next text-primary"><i class="fas fa-chevron-circle-right"></i></div>',
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        arrows: true,
                        prevArrow: '<div type="button" class="slick-prev text-primary"><i class="fas fa-chevron-circle-left"></i></div>',
                        nextArrow: '<div type="button" class="slick-next text-primary"><i class="fas fa-chevron-circle-right"></i></div>',
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5,
                        arrows: true,
                        prevArrow: '<div type="button" class="slick-prev text-primary"><i class="fas fa-chevron-circle-left"></i></div>',
                        nextArrow: '<div type="button" class="slick-next text-primary"><i class="fas fa-chevron-circle-right"></i></div>',
                    }
                }
            ],
        });

        affiliateLinksSlider.onScrollIntoView(
            function() {
                if ( $( '#affiliate-links' ).hasClass( 'show' ) ) {
                    affiliateLinksSlider.slick( 'next' );
                }
            },
            function() {
                if ( $( '#affiliate-links' ).hasClass( 'show' ) ) {
                    let prevSlideIndex = affiliateLinksSlider.slick( 'slickCurrentSlide' ) == 0
                        ? affiliateLinksSlider.slick( 'slickCurrentSlide' ) - 1
                        : affiliateLinksSlides.length - 1;
                    affiliateLinksSlider.slick( 'slickGoTo', prevSlideIndex, false );
                }
            }
        );
    });

});
